module.exports = __webpack_public_path__ + "static/media/ArchivoAdjuntoIcon.bcea36d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MessageBar/ArchivoAdjuntoIcon.svg
// module id = 1811
// module chunks = 0